import BaseApi from './baseApi';
import IRPTQueriesParameters from '../models/IRPTQueriesParameters';
import IAuthentication from '../models/IAuthentication';
export default class RPTQueriesParametersApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "Reports");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetRPTQueriesParameters() : Promise<IRPTQueriesParameters[]> {
        const json = this.getJsonRead();
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var queriesParameters: IRPTQueriesParameters[] = [];
            queriesParameters = response.data as IRPTQueriesParameters[];
            return queriesParameters;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveRPTQueriesParameters(queriesParameters: IRPTQueriesParameters) : Promise<string> {
        const json = this.getJsonSave(queriesParameters);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateRPTQueriesParameters(queriesParameters: IRPTQueriesParameters) : Promise<boolean> {
        const json = this.getJsonUpdate(queriesParameters);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteRPTQueriesParameters(queriesParametersId: string) : Promise<boolean> {
        const json = this.getJsonDelete(queriesParametersId);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDelete(idQueryParameters: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "RPT_Queries",
            "conditions": [{
                "Item1": "RPT_Queries",
                "Item2": "id",
                "Item3": "=",
                "Item4": idQueryParameters
            }]
        };
        return json;
    }

    private getJsonSave(queryParameter: IRPTQueriesParameters) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "id_RPT_Parameters",
                "Item2": queryParameter.idRPTParameters
            }, {
                "Item1": "id_RPT_Queries",
                "Item2": queryParameter.idRPTQueries
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "RPT_QueriesParameters"
        };
        return json;
    }

    private getJsonUpdate(queryParameter: IRPTQueriesParameters) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "id_RPT_Parameters",
                "Item2": queryParameter.idRPTParameters
            }, {
                "Item1": "id_RPT_Queries",
                "Item2": queryParameter.idRPTQueries
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "RPT_QueriesParameters",
            "keyvalue": queryParameter.id
        };
        return json;
    }

    private getJsonRead() : any {
        const json = {
            "fields": [{
                "Item1": "RPT_QueriesParameters",
                "Item2": "id"
            }, {
                "Item1": "RPT_QueriesParameters",
                "Item2": "id_RPT_Parameters"
            }, {
                "Item1": "RPT_Parameters",
                "Item2": "parameterName"
            }, {
                "Item1": "RPT_QueriesParameters",
                "Item2": "id_RPT_Queries"
            }, {
                "Item1": "RPT_Queries",
                "Item2": "queryName"
            }],
            "tables": [{
                "Item1": "RPT_QueriesParameters"
            }, {
                "Item1": "RPT_Parameters"
            }, {
                "Item1": "RPT_Queries"
            }],
            "joins": [{
                "Item1": "RPT_QueriesParameters",
                "Item2": "id_RPT_Parameters",
                "Item3": "RPT_Parameters",
                "Item4": "id"
            }, {
                "Item1": "RPT_QueriesParameters",
                "Item2": "id_RPT_Queries",
                "Item3": "RPT_Queries",
                "Item4": "id"
            }],
            "conditions": [{
                "Item1": "RPT_QueriesParameters",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0"
            }]
        };
        return json;
    }
}
